module.exports = __webpack_public_path__ + "static/media/KaTeX_Math-BoldItalic.753ca3df.woff2";